var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaturskole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.286,7.2a.838.838,0,0,0,1.047-.171l.408.236v1.2a.093.093,0,0,0,.093.093H7.98a.093.093,0,0,0,.093-.093v-1.2l.408-.236A.838.838,0,0,0,9.528,7.2a4.124,4.124,0,0,0,1.049-1.573,4.133,4.133,0,0,0-1.887.123.837.837,0,0,0-.375.992l-.242.14V5.633a.838.838,0,0,0,.671-.821,4.118,4.118,0,0,0-.837-1.7,4.12,4.12,0,0,0-.838,1.7.839.839,0,0,0,.672.821V6.886L7.5,6.746a.837.837,0,0,0-.375-.992,4.133,4.133,0,0,0-1.887-.123A4.124,4.124,0,0,0,6.286,7.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.412,9.474a.481.481,0,0,0-.6-.318l-.071.022a.226.226,0,0,0-.182-.12,8.866,8.866,0,0,0-3.309.547,8.8,8.8,0,0,1,2.858-.793.24.24,0,0,0,.222-.257.227.227,0,0,0-.258-.223A8.629,8.629,0,0,0,9.58,9.425a8.73,8.73,0,0,1,2.7-1.345.241.241,0,0,0-.124-.465c-.14.037-3.281.9-4.22,3.079H7.866c-.94-2.179-4.08-3.042-4.22-3.079a.241.241,0,1,0-.124.465A8.711,8.711,0,0,1,6.239,9.433a8.62,8.62,0,0,0-3.5-1.1.221.221,0,0,0-.258.223.239.239,0,0,0,.222.257A8.807,8.807,0,0,1,5.556,9.6a8.873,8.873,0,0,0-3.308-.546.229.229,0,0,0-.181.118L2,9.156a.482.482,0,0,0-.284.921l5.054,1.559.875.014c.013,0,.024.008.038.008H8.971l5.123-1.581A.482.482,0,0,0,14.412,9.474ZM3.429,9.6a6.521,6.521,0,0,1,2.675.825Zm6.263.831a6.519,6.519,0,0,1,2.7-.833Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturskole);
export default __webpack_public_path__ + "static/media/NATURSKOLE.eadfad6b305aabdb2a70a1d625eb1d2a.svg";
export { ForwardRef as ReactComponent };